// Mock data for Blessing Companion Care website

export const services = [
  {
    id: "companionship",
    icon: "Users",
    title: "Companionship & Conversation",
    shortDescription: "Friendly companionship and emotional support",
    fullDescription: "Loneliness can be one of the hardest parts of aging. Our caregivers provide warm, engaging companionship — sharing stories, playing games, reading together, or simply being present. We build genuine relationships that brighten every day.",
    features: [
      "Friendly conversation and active listening",
      "Games, puzzles, and hobbies",
      "Reading books and newspapers together",
      "Accompaniment to events and outings",
      "Emotional and social support"
    ],
    image: "https://images.unsplash.com/photo-1765896387398-1e1ae8d2eb85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxjYXJlZ2l2ZXIlMjBzZW5pb3IlMjBwYXRpZW50JTIwc21pbGluZ3xlbnwwfHx8fDE3NzgwMTE0NTh8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "meal-preparation",
    icon: "UtensilsCrossed",
    title: "Meal Preparation",
    shortDescription: "Nutritious meals tailored to their needs",
    fullDescription: "Good nutrition is essential for wellbeing. We prepare fresh, nutritious meals tailored to dietary requirements and personal preferences, making mealtimes something to look forward to every day.",
    features: [
      "Custom meal planning based on dietary needs",
      "Fresh, home-cooked breakfast, lunch, and dinner",
      "Grocery shopping and kitchen organization",
      "Safe food handling and nutrition guidance",
      "Cultural and favorite recipes"
    ],
    image: "https://images.unsplash.com/photo-1765200231320-987437f4acc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxoZWFsdGh5JTIwbWVhbCUyMHByZXAlMjBzZW5pb3J8ZW58MHx8fHwxNzc4MDExNDU4fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "medication-reminders",
    icon: "Pill",
    title: "Medication Reminders",
    shortDescription: "Timely reminders for safety and peace of mind",
    fullDescription: "Missed medications can have serious health consequences. Our caregivers provide timely, gentle reminders to ensure medications are taken as prescribed, giving families complete peace of mind.",
    features: [
      "Scheduled medication reminders",
      "Medication organization and tracking",
      "Coordination with healthcare providers",
      "Side-effect monitoring and reporting",
      "Family updates and communication"
    ],
    image: "https://images.unsplash.com/photo-1675169052183-fcad520b4b85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxzZW5pb3IlMjBtZWRpY2F0aW9uJTIwY2FyZWdpdmVyfGVufDB8fHx8MTc3ODAxMTQ4OHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "housekeeping",
    icon: "Home",
    title: "Light Housekeeping",
    shortDescription: "Keeping the home clean, safe and comfortable",
    fullDescription: "A clean, organized home is a safer, happier home. We help maintain a tidy living space with light housekeeping tasks that keep things welcoming and reduce fall risks.",
    features: [
      "Dusting, sweeping, and vacuuming",
      "Laundry and linen changes",
      "Dishwashing and kitchen cleanup",
      "Bathroom tidying",
      "Organizing and decluttering"
    ],
    image: "https://images.pexels.com/photos/9462745/pexels-photo-9462745.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: "transportation",
    icon: "Car",
    title: "Errands & Transportation",
    shortDescription: "Appointments, groceries and more",
    fullDescription: "Maintaining independence means staying connected with the world. We provide safe, reliable transportation to appointments, errands, and social engagements — always with a caring hand.",
    features: [
      "Doctor and medical appointments",
      "Grocery and pharmacy runs",
      "Social visits and community events",
      "Place of worship and religious services",
      "Personal errands and banking"
    ],
    image: "https://images.unsplash.com/photo-1764173039712-da4632d1fa9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxzZW5pb3IlMjB0cmFuc3BvcnRhdGlvbiUyMGNhcnxlbnwwfHx8fDE3NzgwMTE0ODd8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "daily-living",
    icon: "HandHeart",
    title: "Daily Living Support",
    shortDescription: "Assistance with daily routines and activities",
    fullDescription: "Everyday tasks shouldn't feel overwhelming. Our caregivers provide gentle, respectful assistance with daily activities so your loved one can stay comfortable, confident, and independent at home.",
    features: [
      "Personal grooming and hygiene support",
      "Mobility assistance and fall prevention",
      "Dressing and wardrobe assistance",
      "Morning and evening routines",
      "Activity planning and engagement"
    ],
    image: "https://images.unsplash.com/photo-1773227055624-07b515ba87c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxsaWdodCUyMGhvdXNla2VlcGluZyUyMHNlbmlvciUyMGxpdmluZyUyMGVsZGVybHl8ZW58MHx8fHwxNzc4MDExNDg3fDA&ixlib=rb-4.1.0&q=85"
  }
];

export const trustIndicators = [
  {
    icon: "ShieldCheck",
    title: "Trusted & Reliable",
    description: "You can count on us to show up and care."
  },
  {
    icon: "HeartHandshake",
    title: "Compassionate Care",
    description: "We provide support with a loving heart."
  },
  {
    icon: "Users",
    title: "Peace of Mind",
    description: "Knowing your loved one is in good hands."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Margaret Thompson",
    relationship: "Daughter of client",
    quote: "Blessing Companion Care has been a blessing in the truest sense. Since Mom started with them, I can finally sleep at night knowing she is safe, happy, and cared for like family. Their caregiver Angela brightens her whole day.",
    rating: 5,
    location: "Baltimore, MD"
  },
  {
    id: 2,
    name: "Robert & Linda Carter",
    relationship: "Family members",
    quote: "We searched for months for the right care for my father. Blessing is different. They truly listen, they show up on time, and they treat Dad with genuine dignity. I wish we'd found them sooner.",
    rating: 5,
    location: "Silver Spring, MD"
  },
  {
    id: 3,
    name: "Eleanor Williams",
    relationship: "Client, age 82",
    quote: "At my age, I was afraid of losing my independence. My caregiver from Blessing doesn't just help me — she is my friend. We cook, we laugh, we remember the old days together. I look forward to every visit.",
    rating: 5,
    location: "Bethesda, MD"
  },
  {
    id: 4,
    name: "James Okafor",
    relationship: "Son of client",
    quote: "Living out of state, I worried about my mother constantly. The team at Blessing keeps me updated, sends photos, and treats her with such patience. Their professionalism and warmth is something rare.",
    rating: 5,
    location: "Rockville, MD"
  },
  {
    id: 5,
    name: "Grace Bennett",
    relationship: "Daughter of client",
    quote: "When Daddy fell last winter, we were terrified. Blessing's caregivers helped him recover safely at home with patience, encouragement, and kindness. They are simply extraordinary people.",
    rating: 5,
    location: "Columbia, MD"
  },
  {
    id: 6,
    name: "Deborah Mitchell",
    relationship: "Client, age 78",
    quote: "I've tried other services. None compare. Blessing treats me like I matter — not like a task on a checklist. Care that feels like family is exactly right.",
    rating: 5,
    location: "Annapolis, MD"
  }
];

export const blogPosts = [
  {
    id: "signs-loved-one-needs-care",
    title: "7 Gentle Signs Your Loved One May Need a Little Extra Help",
    excerpt: "Recognizing when aging parents or spouses need companion care isn't always easy. Here are the subtle signs families often overlook — and what to do next.",
    category: "Family Guidance",
    readTime: "6 min read",
    date: "November 28, 2025",
    author: "The Blessing Team",
    image: "https://images.unsplash.com/photo-1750853730688-61ba53660e0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxjYXJlZ2l2ZXIlMjBzZW5pb3IlMjBwYXRpZW50JTIwc21pbGluZ3xlbnwwfHx8fDE3NzgwMTE0NTh8MA&ixlib=rb-4.1.0&q=85",
    content: `Aging is a natural chapter of life, but it doesn't have to be walked alone. Many families tell us they wish they had noticed the signs sooner — not to rush their loved one into care, but to bring companionship, safety, and joy back into their days.

Here are seven gentle signs that it may be time to consider companion care:

**1. Missed Medications or Forgotten Appointments**
A stack of unopened pill bottles or a calendar full of scratched-out appointments can signal that daily organization is becoming a challenge.

**2. Changes in Appearance or Hygiene**
When a normally well-groomed parent begins wearing the same clothes repeatedly or skipping showers, this often points to decreased energy or difficulty with daily tasks.

**3. An Unusually Quiet or Disorganized Home**
Piles of mail, untouched laundry, or a refrigerator full of expired food are quiet cries for support.

**4. Increased Isolation**
Canceled lunches with friends, missed church services, or reluctance to leave the house can signal loneliness or loss of confidence.

**5. Unexplained Weight Loss**
Cooking for one is hard. Many seniors skip meals or eat only snacks when mealtimes feel overwhelming.

**6. Mood Changes**
Sadness, irritability, or anxiety are often hidden forms of loneliness — not signs of an aging personality.

**7. A Recent Fall or "Close Call"**
Even minor falls are a major warning. Safe mobility support can prevent serious injury and restore confidence.

If any of these feel familiar, please know: you are not alone, and you don't have to face this alone. A conversation with a trusted companion care provider is a beautiful first step. We are here whenever you're ready.`
  },
  {
    id: "conversations-about-care",
    title: "How to Talk to Aging Parents About Accepting Help",
    excerpt: "Bringing up companion care with a proud parent can feel delicate. Here's a heartfelt guide to starting the conversation with love and respect.",
    category: "Family Guidance",
    readTime: "5 min read",
    date: "November 14, 2025",
    author: "The Blessing Team",
    image: "https://images.unsplash.com/photo-1765896387377-e293914d1e69?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxjYXJlZ2l2ZXIlMjBzZW5pb3IlMjBwYXRpZW50JTIwc21pbGluZ3xlbnwwfHx8fDE3NzgwMTE0NTh8MA&ixlib=rb-4.1.0&q=85",
    content: `For many seniors, accepting help feels like admitting defeat. But in truth, welcoming support is an act of wisdom — a way to preserve independence, dignity, and joy for the years ahead.

Here is how to open the conversation with grace:

**Start with love, not logistics.**
Instead of "You need help," try "I love you, and I want us to enjoy more time together without stress."

**Listen first, solve later.**
Ask what they find hardest about their day. Their answers may surprise you and shape the conversation naturally.

**Frame care as companionship, not caregiving.**
Most seniors welcome a friend, a helper, a warm presence — far more readily than they welcome a "nurse."

**Involve them in every decision.**
From who the caregiver is to what hours work best, agency matters. Hand them the steering wheel.

**Start small.**
A few hours a week for companionship and meal preparation can beautifully transition into more support over time.

The goal isn't to take control. It's to give your loved one back the gift of enjoying life at home — with someone wonderful by their side.`
  },
  {
    id: "home-safety-seniors",
    title: "10 Simple Changes That Make a Home Safer for Seniors",
    excerpt: "Small adjustments can prevent the most common accidents at home. A practical, room-by-room checklist for peace of mind.",
    category: "Safety & Wellness",
    readTime: "7 min read",
    date: "October 30, 2025",
    author: "The Blessing Team",
    image: "https://images.pexels.com/photos/9462745/pexels-photo-9462745.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    content: `Home is where we feel most ourselves. For seniors, keeping home safe means keeping independence intact. Here are ten simple, affordable changes that reduce accidents and increase confidence:

**1. Add grab bars in bathrooms.** Near toilets and inside showers. A five-minute install can prevent life-changing falls.

**2. Remove loose rugs.** Or secure them with grip pads. Slippery rugs are a top cause of falls.

**3. Brighten the lighting.** Especially in hallways, stairs, and bathrooms. LED bulbs are bright and energy-efficient.

**4. Install nightlights.** Motion-sensing lights in hallways and bathrooms reduce nighttime accidents.

**5. Clear walking paths.** Remove cords, clutter, and low furniture from regular walking routes.

**6. Non-slip mats in the shower.** Inexpensive and lifesaving.

**7. Raise the toilet seat.** A higher seat reduces strain on knees and hips.

**8. Keep a phone accessible.** In every main room, within easy reach.

**9. Label medications clearly.** Or use a weekly pill organizer.

**10. Add a sturdy chair near the door.** Sitting to put on shoes is safer than bending or balancing.

Most importantly: have a trusted companion who notices what you might miss. A caregiver's watchful eye is the greatest home safety upgrade of all.`
  },
  {
    id: "nutrition-for-seniors",
    title: "The Power of a Shared Meal: Nutrition Tips for Aging Well",
    excerpt: "Food is love, medicine, and memory all at once. How to nourish aging bodies — and hearts — through mealtimes.",
    category: "Safety & Wellness",
    readTime: "5 min read",
    date: "October 12, 2025",
    author: "The Blessing Team",
    image: "https://images.unsplash.com/photo-1765200231320-987437f4acc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxoZWFsdGh5JTIwbWVhbCUyMHByZXAlMjBzZW5pb3J8ZW58MHx8fHwxNzc4MDExNDU4fDA&ixlib=rb-4.1.0&q=85",
    content: `Nutrition matters more, not less, as we age. But for many seniors, cooking for one feels lonely, and eating well becomes harder.

Here's how to support nourishing, joyful mealtimes:

**Prioritize protein.** Older adults need more protein to maintain muscle. Eggs, yogurt, fish, beans, and lean chicken are perfect.

**Don't forget fiber and fluids.** Constipation is common — whole grains, fruits, and plenty of water help.

**Eat the rainbow.** Colorful vegetables bring vitamins, antioxidants, and joy to the plate.

**Watch the salt.** High sodium contributes to blood pressure issues. Fresh herbs bring flavor without the harm.

**Plan simple meals ahead.** Batch-cooking makes mealtimes easier and reduces skipped meals.

**Most importantly — eat together.**
Research shows seniors eat more, eat better, and enjoy food more when they share a meal with someone. A caregiver who cooks and eats alongside is providing far more than nutrition — it's connection, dignity, and love on a plate.`
  },
  {
    id: "aging-in-place",
    title: "Aging in Place: Why Home Is the Best Medicine",
    excerpt: "Science and story agree — most seniors thrive at home. Here's why, and how companion care makes it possible.",
    category: "Aging in Place",
    readTime: "6 min read",
    date: "September 28, 2025",
    author: "The Blessing Team",
    image: "https://images.unsplash.com/photo-1773227055624-07b515ba87c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxsaWdodCUyMGhvdXNla2VlcGluZyUyMHNlbmlvciUyMGxpdmluZyUyMGVsZGVybHl8ZW58MHx8fHwxNzc4MDExNDg3fDA&ixlib=rb-4.1.0&q=85",
    content: `When asked where they would most like to grow old, nearly 9 out of 10 older adults answer the same way: at home.

And there's good reason for that.

**Home means continuity.**
Familiar smells, neighbors, rituals, and rooms hold decades of meaning. Memory clings to these places.

**Home means control.**
Seniors at home wake when they want, eat what they love, and keep their own rhythms.

**Home means family.**
Grandchildren visit more often. Pets stay. Traditions continue.

Companion care makes aging in place possible. With a trusted caregiver for a few hours a day — or around the clock — seniors can continue living the life they built, with just a little extra support to keep it beautiful.

If your loved one has been asking to stay home, listen to them. With the right partner, home truly is the best medicine.`
  },
  {
    id: "dementia-companionship",
    title: "The Quiet Comfort of Companionship for Dementia",
    excerpt: "Dementia changes many things — but the need for human connection is not one of them. How gentle companionship makes a profound difference.",
    category: "Specialized Care",
    readTime: "7 min read",
    date: "September 10, 2025",
    author: "The Blessing Team",
    image: "https://images.unsplash.com/photo-1765896387387-0538bc9f997e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxjYXJlZ2l2ZXIlMjBzZW5pb3IlMjBwYXRpZW50JTIwc21pbGluZ3xlbnwwfHx8fDE3NzgwMTE0NTh8MA&ixlib=rb-4.1.0&q=85",
    content: `A dementia diagnosis brings uncertainty — but it does not erase the person you love. With patience, presence, and the right support, there are still beautiful moments to share.

**Meet them where they are.**
Enter their reality with love. Arguing with memory loss only brings frustration; gentle agreement brings peace.

**Simple routines, simple joys.**
Predictable schedules, familiar music, and comforting rituals reduce anxiety beautifully.

**Touch matters.**
A warm hand, a kind voice, a shared smile — these reach hearts even when words fade.

**Protect quality of life.**
Walks in the garden, old photographs, favorite foods, spiritual practices — the small joys remain powerful.

**Care for the caregiver, too.**
Family members living with dementia at home need rest. Regular companion care gives families the breath they need to keep loving well.

Every person living with dementia deserves to feel seen, safe, and cherished — always. That is the heart of everything we do.`
  }
];

export const faqs = [
  {
    question: "What is companion care?",
    answer: "Companion care is non-medical, in-home support focused on emotional wellbeing, daily routines, and keeping seniors safe and connected. It includes conversation, meal preparation, light housekeeping, transportation, medication reminders, and assistance with daily activities."
  },
  {
    question: "How do I get started?",
    answer: "The first step is a friendly, no-obligation conversation. Call us at (123) 456-7890 or fill out our contact form. We will schedule a free home assessment, listen to your family's needs, and create a personalized care plan together."
  },
  {
    question: "Are your caregivers insured and background-checked?",
    answer: "Absolutely. Every caregiver is carefully screened, background-checked, and insured. We only work with people we would trust with our own family members."
  },
  {
    question: "How many hours of care do you provide?",
    answer: "We offer flexible care schedules — from a few hours a week to 24/7 support. Our care plans are designed around your family's unique needs and adjust as needs change."
  },
  {
    question: "What areas do you serve?",
    answer: "We proudly serve our local community with love and dedication. Call us to confirm service in your neighborhood — we are always expanding to help more families."
  },
  {
    question: "Can I choose my caregiver?",
    answer: "Yes. We carefully match caregivers to each client based on personality, needs, and preferences. If the match isn't perfect, we will happily reassign — your comfort comes first."
  }
];

export const companyInfo = {
  name: "Blessing Companion Care",
  tagline: "Care that feels like family",
  phone: "(202) 925-9701",
  email: "info@blessingcompanioncare.com",
  website: "BlessingCompanionCare.com",
  address: "Proudly serving Maryland communities with love and dedication",
  hours: "Available 24 hours a day, 7 days a week",
  promise: "We treat your loved one like our own family — with patience, kindness, and genuine care every day.",
  mission: "Providing reliable, compassionate support for seniors who want to live safely and comfortably at home. We are here so families have peace of mind and loved ones have the care they deserve.",
  values: ["Compassion", "Respect", "Trust"]
};
